import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import Button from '@components/dataEntry/button/Button';

const Div = styled.div`
  width: 100%;
  min-height: 60dvh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: var(--textColor);
  text-align: center;
  padding: 24px;
`;

const Description = styled.p`
  color: var(--subTextColor);
  font-size: 14px;
  line-height: 1.5;
`;

function NoMatch() {
  const navigate = useNavigate();

  return (
    <Div>
      <h6>존재하지 않는 경로입니다.</h6>
      <Description>
        요청하신 페이지를 찾을 수 없습니다.
        <br />
        게시글이 삭제되었거나 주소가 변경되었을 수 있어요.
      </Description>
      <Button shape="filled" onClick={() => navigate('/')}>
        홈으로 이동
      </Button>
    </Div>
  );
}

export default NoMatch;
